import React, { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";

const socket = io("http://172.104.206.4:5000"); // change port

export default function Expert() {
  const localVideo = useRef();
  const remoteVideo = useRef();
  const pcRef = useRef(null);
  const [callerId, setCallerId] = useState(null);

  const myId = "67727bed5ed12a8aa33376fe";

  useEffect(() => {
    socket.emit("register", { userId: myId, role: "expert" });

    socket.on("incomingCall", async ({ fromUser }) => {
      setCallerId(fromUser);
      await startMedia(fromUser);
    });

    socket.on("callOffer", async ({ offer }) => {
      if (!pcRef.current) return;

      await pcRef.current.setRemoteDescription(offer);
      const answer = await pcRef.current.createAnswer();
      await pcRef.current.setLocalDescription(answer);

      socket.emit("callAnswer", { answer, to: callerId });
    });

    socket.on("callCandidate", async ({ candidate }) => {
      if (pcRef.current) await pcRef.current.addIceCandidate(candidate);
    });

    socket.on("endCallExpertUser", ({ endedBy }) => {
      if (pcRef.current) {
        pcRef.current.close();
        pcRef.current = null;
      }
      if (localVideo.current?.srcObject) {
        localVideo.current.srcObject.getTracks().forEach(track => track.stop());
      }
      alert("Call ended by " + endedBy);
      setCallerId(null);
    });

    return () => socket.off();
  }, [callerId]);

  const startMedia = async (to) => {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    localVideo.current.srcObject = stream;

    pcRef.current = new RTCPeerConnection({
      iceServers: [{ urls: "stun:stun.l.google.com:19302" }]
    });

    stream.getTracks().forEach(track => pcRef.current.addTrack(track, stream));

    pcRef.current.ontrack = e => {
      remoteVideo.current.srcObject = e.streams[0];
    };

    pcRef.current.onicecandidate = e => {
      if (e.candidate) socket.emit("callCandidate", { candidate: e.candidate, to });
    };
  };

  const endCall = () => {
    if (!callerId) return;

    socket.emit("endCallExpertUser", { to: callerId, by: "expert" });

    if (pcRef.current) {
      pcRef.current.close();
      pcRef.current = null;
    }
    if (localVideo.current?.srcObject) {
      localVideo.current.srcObject.getTracks().forEach(track => track.stop());
    }

    setCallerId(null);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <h2>Expert Panel</h2>
      <video ref={localVideo} autoPlay muted playsInline width="250" />
      <video ref={remoteVideo} autoPlay playsInline width="250" />

      <br /><br />
      {callerId && (
        <>
          <p>📞 In call with {callerId}</p>
          <button onClick={endCall}>❌ End Call</button>
        </>
      )}
    </div>
  );
}
